import { render, staticRenderFns } from "./ViewOrEditTucowsRegistrar.vue?vue&type=template&id=c3c37ea0"
import script from "./ViewOrEditTucowsRegistrar.vue?vue&type=script&lang=js"
export * from "./ViewOrEditTucowsRegistrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports